"use strict";

exports.__esModule = true;
exports.ElementLayoutVisibilityControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _MultiRoleSelector = require("../../../Role/MultiRoleSelector");
var _User = require("../../../User");
var _Core = require("../../../Core");
var _styles = require("../../common/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Controls for changing the size of the selected element
 */
var ElementLayoutVisibilityControlGroup = exports.ElementLayoutVisibilityControlGroup = function ElementLayoutVisibilityControlGroup(props) {
  var _element$props, _element$props2, _element$props3, _element$props4;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var areRolesVisibilityEmpty = ((_element$props = element.props) == null || (_element$props = _element$props.rolesVisibility) == null ? void 0 : _element$props.length) === 0;
  var areUsersVisibilityEmpty = ((_element$props2 = element.props) == null || (_element$props2 = _element$props2.usersVisibility) == null ? void 0 : _element$props2.length) === 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ElementLayoutVisibilityControlGroup.options"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.LayoutElementTitle, null, translate("ElementLayoutVisibilityControlGroup.visibility.label", "Visibility")), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: "#5c7080",
      fontSize: "12px",
      marginTop: "5px",
      marginBottom: "15px",
      textAlign: "justify"
    }
  }, translate("ElementLayoutVisibilityControlGroup.visibility.helperText", "Show screen based on the user or their role. Visibility will be an union of selected roles and users."))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.roles.label",
      defaultMessage: "Visibility roles"
    }),
    helperText: areRolesVisibilityEmpty ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.roles.helperTextError",
      defaultMessage: "Select at least one role for which the screen will be visible."
    }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.roles.helperText",
      defaultMessage: "Roles for which the screen will be visible."
    }),
    intent: areRolesVisibilityEmpty ? _core.Intent.DANGER : _core.Intent.NONE
  }, /*#__PURE__*/_react["default"].createElement(_MultiRoleSelector.MultiRoleSelector, {
    style: {
      maxWidth: 200
    },
    value: (_element$props3 = element.props) == null ? void 0 : _element$props3.rolesVisibility,
    onChange: function onChange(e) {
      elementEditor.setProp(path, "rolesVisibility", e);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.users.label",
      defaultMessage: "Visibility users"
    }),
    helperText: areUsersVisibilityEmpty ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.users.helperTextError",
      defaultMessage: "Select at least one user for which the screen will be visible."
    }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ElementLayoutVisibilityControlGroup.users.helperText",
      defaultMessage: "Users for which the screen will be visible."
    }),
    intent: areUsersVisibilityEmpty ? _core.Intent.DANGER : _core.Intent.NONE
  }, /*#__PURE__*/_react["default"].createElement(_User.UsersSelector, {
    style: {
      maxWidth: 200
    },
    value: (_element$props4 = element.props) == null ? void 0 : _element$props4.usersVisibility,
    onChange: function onChange(e) {
      elementEditor.setProp(path, "usersVisibility", e);
    }
  })));
};